<template>
  <div>
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-top: -3px">
              <h3 class="text-white">Définir votre mot de passe</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 ml-auto mr-auto">
      <form role="form" @submit.prevent="handleSubmit()">
        <card class="card-login card-plain">
          <div>
            <fg-input
              v-model="form.data.attributes.password"
              type="password"
              name="password"
              class="no-border form-control-lg"
              placeholder="Mot de passe"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              :error="apiValidationErrors.password"
            >
            </fg-input>

            <fg-input
              v-model="form.data.attributes.password_confirmation"
              type="password"
              name="password_confirmation"
              class="no-border form-control-lg"
              placeholder="Confirmer le mot de passe"
              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
              :error="apiValidationErrors.password_confirmation"
            >
            </fg-input>

            <div v-if="form.data.attributes.password" class="reset-password-meter" aria-live="polite">
              <div class="reset-password-meter-heading">
                <span>Robustesse</span>
                <strong :class="`strength-${passwordStrength.level}`">{{ passwordStrength.label }}</strong>
              </div>
              <div class="reset-password-meter-track" role="progressbar" aria-label="Robustesse du mot de passe"
                   aria-valuemin="0" aria-valuemax="5" :aria-valuenow="passwordStrength.score">
                <span v-for="segment in 5" :key="segment"
                      :class="{ active: segment <= passwordStrength.score, [`strength-${passwordStrength.level}`]: segment <= passwordStrength.score }"></span>
              </div>
              <small>8 caractères minimum, avec majuscule, minuscule, chiffre et caractère spécial.</small>
            </div>
          </div>

          <div slot="footer">
            <n-button native-type="submit" type="primary" round block :disabled="isSaving">
              {{ isSaving ? 'Enregistrement…' : 'Enregistrer le mot de passe' }}
            </n-button>
          </div>
        </card>
      </form>
    </div>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
export default {
  mixins: [formMixin],
  name: "PasswordEmail",
  data() {
    return {
      form: {
        data: {
          type: "password-reset",
          attributes: {
            password: "",
            password_confirmation: "",
            token: "",
            email: "",
          },
        },
      },
      isSaving: false,
    };
  },

  computed: {
    passwordStrength() {
      const password = this.form.data.attributes.password || "";
      const score = [
        password.length >= 8,
        /[A-Z]/.test(password),
        /[a-z]/.test(password),
        /[0-9]/.test(password),
        /[^A-Za-z0-9]/.test(password),
      ].filter(Boolean).length;

      if (score <= 2) return { score, label: "Faible", level: "weak" };
      if (score <= 4) return { score, label: "Moyen", level: "medium" };
      return { score, label: "Fort", level: "strong" };
    },
  },

  mounted() {
    this.form.data.attributes.email = this.$route.query.email;
    this.form.data.attributes.token = this.$route.query.token;
  },

  beforeDestroy() {
    this.$router.replace({ query: null });
  },

  methods: {
    async handleSubmit() {
      if (this.isSaving) return;

      const attributes = this.form.data.attributes;
      if (this.passwordStrength.score < 5) {
        await this.$store.dispatch(
          "alerts/error",
          "Le mot de passe ne respecte pas toutes les règles de sécurité."
        );
        return;
      }
      if (attributes.password !== attributes.password_confirmation) {
        await this.$store.dispatch(
          "alerts/error",
          "Les mots de passe ne correspondent pas."
        );
        return;
      }

      this.isSaving = true;
      try {
        await this.$store.dispatch("reset/createNewPassword", this.form.data);
        await this.$store.dispatch(
          "alerts/success",
          "Votre mot de passe a été enregistré. Vous pouvez maintenant vous connecter."
        );
        await this.$router.push({ name: "Login" });
      } catch (error) {
        await this.$store.dispatch(
          "alerts/error",
          "Le mot de passe n’a pas pu être enregistré."
        );
        this.setApiValidation(error.response.data.errors);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.reset-password-meter { color: #fff; margin: 4px 0 20px; text-align: left; }
.reset-password-meter-heading { display: flex; font-size: 12px; justify-content: space-between; margin-bottom: 7px; }
.reset-password-meter-track { display: grid; gap: 5px; grid-template-columns: repeat(5, 1fr); }
.reset-password-meter-track span { background: rgba(255, 255, 255, .25); border-radius: 4px; height: 6px; }
.reset-password-meter-track span.active.strength-weak { background: #ff6b6b; }
.reset-password-meter-track span.active.strength-medium { background: #ffd166; }
.reset-password-meter-track span.active.strength-strong { background: #56e39f; }
.reset-password-meter small { display: block; margin-top: 8px; }
.strength-weak { color: #ffb3b3; }
.strength-medium { color: #ffe29a; }
.strength-strong { color: #8bf0ba; }
</style>
